import { useState, useCallback } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const backendURL = window.__ENV && window.__ENV.backendURL;
const axiosClient = axios.create({ baseURL: `${backendURL}`, timeout: 20000, withCredentials: true, credentials: 'include' });
const config = { headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };

export default function useCart(userid,setShowProgress,setOpenSnackBar,setMessage,t,signIn,    setOpenLogInModal,
) {
  const [cart, setCart] = useState();
  const [itemsCount, setItemsCount] = useState(0);
  const history = useHistory();
  // Add to cart
  const addtoCart = useCallback(async (product, quantity) => {
    const url = `${process.env.REACT_APP_SERVER_URL}/carts`;
    return axiosClient.post(url, {
      productId: product._id,
      quantity,
      product,
      userId: userid,   
    }, config);
  }, [userid]);
 const handleAddtoCart = async (product,quantity,option)=>{
  /*   sendOrderConfirmationEmail(userid,"abdulrazakneate@gmail.com") */
  if(product.stock.availablestock >0 ){
    if (userid && localStorage.getItem('loggedin')==="true"){
      
    setShowProgress(true)
    addtoCart(product,quantity).then((response) => {
     // console.log(response.data);
     setShowProgress(false)

      if (response.status===200){
        setCart(response.data.cart)
        setItemsCount(response.data.cart.items.length);
       // handleUnprocessedOrders()
      if (  option ==='buynow' ) history.push('/cart')
      
      }else{
        
      
      }
      
    })
      }else{
        setMessage({body:t("alerts.please_sign_in"),severity:'info'})
        setOpenSnackBar(true)
         //history.push('/account')
        //signIn(["payments","username","wallet_address"])
        setOpenLogInModal(true)

      }

  }else {
     setMessage({body:t("alerts.porduct_out_of_stock"),severity:'info'})
     setOpenSnackBar(true)
  }
}
  // Remove from cart
  const deleteFromCart = useCallback(async (productId) => {
    const url = `${process.env.REACT_APP_SERVER_URL}/carts/removeitem/${userid}`;
    return axiosClient.patch(url, {
      productId,
      userId: userid,
    }, config);
  }, [userid]);

  // Update 
    const  handleRemoveFromCart = async (productId)=>{
      setShowProgress(true)
         deleteFromCart(productId).then((response)=>{
          setShowProgress(false)
           if (response.status===200){
             //console.log(response)
             setCart(response.data.cart)
             setItemsCount(response.data.cart.items.length);
  
           }
         })
    }
  const updateCartQty = useCallback((productId, quantity, price, shippingFees) => {
    const url = `${process.env.REACT_APP_SERVER_URL}/carts/quantity/${productId}`;
    return axiosClient.patch(url, {
      productId,
      quantity,
      price,
      shippingFees,
      userId: userid,
    }, config);
  }, [userid]);

   const handleUpdateCartQty = async (productId,quantity,price,shippingFees,currentstock)=>{
    console.log(`${quantity} ${currentstock}`)
         if(currentstock >= quantity){
          if (quantity>=1){
            setShowProgress(true)
            updateCartQty(productId,quantity,price,shippingFees).then((response)=>{
               setShowProgress(false)

              if (response.status===200){
               // console.log(response.data.cart.items)
                setCart(response.data.cart)
                setItemsCount(response.data.cart.items.length);

               } 
             })
          }
         } else if(currentstock === 0) {
         /*  setMessage({body:`only ${currentstock} left in stock  !`,severity: 'info'})
          setOpenSnackBar(true) */
          handleupdateSelection(productId,false,currentstock)
         }
        else {
          setMessage({body:t("alerts.stockleft",{currentstock:currentstock}),severity:'info'})
          setOpenSnackBar(true)
         }  /* */
          
  }
  const emptyCart = async () =>{

    const url = `${process.env.REACT_APP_SERVER_URL}/carts/${userid}`;
   
 
    return axiosClient.patch(url,{},config).then((response)=>{
       // setShowProgress(false)
         if (response.status===200){
           //console.log(response)
           setCart(response.data.cart)
           setItemsCount(response.data.cart.items.length);

         }
      })
  
  };
 const handleupdateSelection = async (productId,checked,quantity)=>{
   //  setShowProgress(true)   
       console.log(checked)
 
     updateSelection(productId,checked).then((response)=>{
      // setShowProgress(false)
       
         if (response.status===200){
             try{
            // console.log(response.data.cart.items)
               setCart(response.data.cart)
               setItemsCount(response.data.cart.items.length);
 
               const currentstock=response.data.currentstock
               if (currentstock <=0){
                 //setMessage({body:t("alerts.zero_stock_left"),severity: 'info'})
                 //setOpenSnackBar(true)
               }
             }catch(err){
               console.log(err)
             }
 
           //  handleUnprocessedOrders()
          } 
        })
     
    }
   const updateSelection =(productId,checked)=>{
    // console.log(value)
     const url = `${process.env.REACT_APP_SERVER_URL}/carts/item/selection`;
      
  
     return axiosClient.patch(url,  {
       productId:productId,
       selected:checked,
       userId:userid,
 
     },config)
   
   };
 

   const handleupdateColorSize = async (productId,type,value)=>{
    
      updateColorAndSizeSpecs(productId,type,value).then((response)=>{
          if (response.status===200){
           // console.log(response.data.cart.items)
            setCart(response.data.cart)
            setItemsCount(response.data.cart.items.length);
  
           } 
         })
      
     }
    const updateColorAndSizeSpecs =(productId,type,value)=>{
      
      const url = `${process.env.REACT_APP_SERVER_URL}/carts/specs/colorandsize`;
       
   
      return axiosClient.patch(url,  {
        productId:productId,
        type:type,
        value:value,
        userId:userid,
      },config)
    
    };
  return {
    cart,
    setCart,
    itemsCount,
    setItemsCount,
    handleAddtoCart,
    handleRemoveFromCart,
    handleUpdateCartQty,
    emptyCart,
    handleupdateColorSize,
    handleupdateSelection
  };
}
